import {
  canonicalizeSourceRouteId,
  type IHttpRedirectInfo,
  type IMergedRoute,
} from '../../../dist_ts_interfaces/data/route-management.js';

export type TRouteOwnerFilter = 'all' | 'operator' | 'gatewayClient' | 'system';
export type TResolvedRouteOwner = Exclude<TRouteOwnerFilter, 'all'>;

export function getRouteOwner(route: IMergedRoute): TResolvedRouteOwner {
  if (route.metadata?.ownerType === 'gatewayClient') return 'gatewayClient';
  if (route.metadata?.ownerType === 'system') return 'system';
  if (route.metadata?.ownerType === 'operator') return 'operator';
  return route.origin === 'api' ? 'operator' : 'system';
}

export function routeMatchesOwner(
  route: IMergedRoute,
  ownerFilter: TRouteOwnerFilter,
): boolean {
  return ownerFilter === 'all' || getRouteOwner(route) === ownerFilter;
}

function getCanonicalRouteIds(route: IMergedRoute): string[] {
  const configuredRouteId = (route.route as { id?: string }).id;
  return [route.id, configuredRouteId]
    .filter((routeId): routeId is string => Boolean(routeId))
    .map(canonicalizeSourceRouteId);
}

export function redirectMatchesOwner(
  redirect: IHttpRedirectInfo,
  mergedRoutes: IMergedRoute[],
  ownerFilter: TRouteOwnerFilter,
): boolean {
  if (ownerFilter === 'all') return true;

  const sourceRouteIds = new Set(redirect.sourceRouteIds.map(canonicalizeSourceRouteId));
  return mergedRoutes.some((route) => {
    return getCanonicalRouteIds(route).some((routeId) => sourceRouteIds.has(routeId))
      && getRouteOwner(route) === ownerFilter;
  });
}
